export function initAdBlock() {
    const block = document.querySelector(".ad.fl-block")
    if (block) {
        setupAdBlock(block)
    }
}

function setupAdBlock(block) {
    const currentId = block.id
    if (window.matchMedia("(max-width: 600px)").matches) {
        block.id = currentId + "mob"
    } else {
        block.id = currentId
    }
}
